import { useEffect, useState } from "react";
import { Link } from "react-router-dom";
import { ArrowUpRight, MapPin } from "lucide-react";
import { Reveal, MaskedLinesInView } from "./Reveal";
import { api } from "../lib/site";

const fmtDate = (d) => new Date(d).toLocaleDateString("en-US", { month: "short", day: "numeric" });

export default function LatestJobs() {
  const [jobs, setJobs] = useState([]);

  useEffect(() => {
    api.get("/jobs/latest", { params: { limit: 6 } }).then((r) => setJobs(r.data)).catch(() => {});
  }, []);

  if (!jobs.length) return null;

  return (
    <section data-testid="home-latest-jobs" className="mx-auto max-w-[1500px] px-6 md:px-10 py-24 md:py-32">
      <div className="grid grid-cols-1 lg:grid-cols-12 gap-8 items-end mb-12">
        <div className="lg:col-span-7">
          <p className="overline text-flame mb-5">Hiring now · Job seekers</p>
          <h2 className="font-display uppercase tracking-tighter leading-[0.9] text-5xl md:text-7xl">
            <MaskedLinesInView lines={["Newest", <span key="j" className="text-cobalt">open jobs</span>]} />
          </h2>
        </div>
        <div className="lg:col-span-4 lg:col-start-9">
          <p className="text-muted-foreground mb-6">Fresh openings across Southern California, updated as they're posted. Check back often.</p>
          <Link to="/jobs" data-testid="latest-jobs-view-all" className="inline-flex items-center gap-2 bg-cobalt text-white px-6 py-3 rounded-full overline hover:bg-flame transition-colors duration-300">
            View all jobs <ArrowUpRight size={14} />
          </Link>
        </div>
      </div>
      <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-3 border-t border-l border-border">
        {jobs.map((j, i) => (
          <Reveal key={j.id} delay={i * 0.06}>
            <Link to={`/jobs?postid=${j.id}`} data-testid={`latest-job-${j.id}`} className="group flex flex-col justify-between h-full min-h-[200px] border-b border-r border-border p-7 hover:bg-ink hover:text-bone transition-colors duration-300">
              <div className="flex items-center justify-between overline text-muted-foreground group-hover:text-bone/60">
                <span>{j.job_type || "Open role"}</span>
                {j.posted_at && <span>{fmtDate(j.posted_at)}</span>}
              </div>
              <p className="font-display uppercase tracking-tight text-2xl md:text-3xl leading-tight my-5">{j.title}</p>
              <div className="flex items-center justify-between text-sm">
                <span className="flex items-center gap-1.5"><MapPin size={14} className="text-flame" /> {j.location}</span>
                <span className="flex items-center gap-2">
                  {j.pay && <span className="font-semibold text-cobalt group-hover:text-bone">${j.pay.toFixed(2)}/hr</span>}
                  <ArrowUpRight size={16} className="transition-transform duration-300 group-hover:translate-x-1 group-hover:-translate-y-1" />
                </span>
              </div>
            </Link>
          </Reveal>
        ))}
      </div>
    </section>
  );
}
